import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { List } from 'immutable';
import { AchDebit } from '../../../settings-data/sub-models/company-settings/ach-debit.model';
import { PercentagePipe } from '../../../shared/pipes/percentage/percentage.pipe';
import { MoneyPipe } from '../../../shared/pipes/money/money.pipe';

@Injectable()
export class BankTransferInfoDialogBuilder {
  constructor(
    private _translateService: TranslateService,
    private _percentagePipe: PercentagePipe,
    private _moneyPipe: MoneyPipe
  ) {}

  buildDescription(achDebit: AchDebit, locale: string): string {
    const currencyCode = achDebit.currencyCode;
    const translateParams = {
      feesPercentage: this._percentagePipe.transform(
        achDebit.feesPercentage,
        locale
      ),
      feesMaximum: this._moneyPipe.transform(
        achDebit.feesMaximum,
        currencyCode,
        locale
      ),
      feesMinimum: this._moneyPipe.transform(
        achDebit.feesMinimum,
        currencyCode,
        locale
      ),
    };

    return this._translateService.instant(
      'DIALOG.PAYMENTS.DESCRIPTION.SETUP_BANK_TRANSFER_2',
      translateParams
    );
  }

  buildListItems(): List<string> {
    return List([
      this._translateService.instant(
        'DIALOG.PAYMENTS.ITEM.ENABLE_BANK_PAYMENTS'
      ),
      this._translateService.instant(
        'DIALOG.PAYMENTS.ITEM.LINK_BANK_ACCOUNT_WITH_STRIPE'
      ),
    ]);
  }
}
